import type { TopicExercises } from "~/features/computer/data/exercises/exercise.types";

export const loopsExercises: TopicExercises = {
  mcqs: [
    {
      id: "loop1",
      question: "for i in range(1, 4) kitni values print karega?",
      options: ["2", "3", "4", "1"],
      correctIndex: 1,
      explanation: "range(1, 4) mein 1, 2, 3 aata hai. End value include nahi hoti.",
    },
    {
      id: "loop2",
      question: "While loop kab rukti hai?",
      options: ["Jab condition false ho", "Jab condition true ho", "Kabhi nahi", "Sirf 1 dafa"],
      correctIndex: 0,
      explanation: "While loop tab tak chalti hai jab tak condition true ho. False hote hi ruk jati hai.",
    },
  ],
  short: [
    {
      id: "loops-short-1",
      question: "For loop aur while loop mein aik farq likho.",
      answer: "For loop tab useful hota hai jab count ya items clear hon. While loop condition-based hota hai.",
    },
  ],
  long: [
    {
      id: "loops-long-1",
      question: "1 se 5 tak numbers print karne ka loop likho.",
      solution: "For loop use karo kyun ke count clear hai.",
      code: "for i in range(1, 6):\n    print(i)",
    },
  ],
};
